(function() {
  function initRoot(root) {
    if (root.dataset.sdjhsInitialized === 'true') return;
    root.dataset.sdjhsInitialized = 'true';

  function initHero() {
    const hero = root.querySelector('[data-sdjhs-hero]');
    if (!hero) return;

    const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
    const tabs = Array.from(hero.querySelectorAll('[data-hero-tab]'));

    if (!slides.length || !tabs.length) return;

    const films = slides.map(slide => initHeroFilm(slide, hero)).filter(Boolean);
    const activate = (index) => {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', String(i !== index));
      });
      hero.classList.toggle('is-cinema', !!slides[index]?.querySelector('[data-sdjhs-film]'));
      films.forEach(film => film.sync());
      tabs.forEach((tab, i) => tab.classList.toggle('is-active', i === index));
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(Number(tab.dataset.index)));
    });
    activate(Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active'))));
  }


  function initHeroFilm(slide, hero) {
    const video = slide.querySelector('[data-sdjhs-film]');
    const button = slide.querySelector('[data-sdjhs-film-toggle]');
    if (!video || !button) return null;
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const mobile = matchMedia('(max-width: 749px)');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let preference = null;
    let pending = false;
    let failed = false;
    let disposed = false;
    const eligible = () => !disposed && visible && slide.classList.contains('is-active') && !document.hidden;
    const wanted = () => eligible() && !failed && preference !== false &&
      (preference === true || (!reduce.matches && !navigator.connection?.saveData));
    const paint = () => {
      button.textContent = video.paused ? 'Play' : 'Pause';
      button.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
    };
    const source = () => mobile.matches ? video.dataset.mobile : video.dataset.desktop;
    const load = () => {
      if (video.getAttribute('src') === source()) return;
      video.classList.remove('is-ready');
      video.src = source();
      video.muted = true;
      video.load();
    };
    const sync = () => {
      if (!wanted()) { video.pause(); paint(); return; }
      load();
      if (pending || !video.paused) return;
      pending = true;
      video.play().then(() => { if (!wanted()) video.pause(); }).catch(() => {}).finally(() => {
        pending = false;
        if (!disposed) paint();
      });
    };
    button.hidden = false;
    button.addEventListener('click', () => {
      preference = video.paused;
      sync();
    }, options);
    video.addEventListener('playing', () => {
      if (!wanted()) { video.pause(); return; }
      video.classList.add('is-ready');
      paint();
    }, options);
    video.addEventListener('pause', paint, options);
    video.addEventListener('error', () => {
      failed = true;
      video.classList.remove('is-ready');
      button.hidden = true;
    }, options);
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      sync();
    }, { threshold: .15 });
    observer.observe(hero);
    document.addEventListener('visibilitychange', sync, options);
    window.addEventListener('pagehide', () => video.pause(), options);
    window.addEventListener('pageshow', sync, options);
    reduce.addEventListener('change', () => { preference = null; sync(); }, options);
    mobile.addEventListener('change', () => {
      video.pause();
      video.classList.remove('is-ready');
      video.removeAttribute('src');
      video.load();
      failed = false;
      button.hidden = false;
      sync();
    }, options);
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(slide)) return;
      disposed = true;
      video.pause();
      video.removeAttribute('src');
      video.load();
      observer.disconnect();
      abort.abort();
    }, options);
    return { sync };
  }

  function initShowcase() {
    const showcase = root.querySelector('[data-sdjhs-showcase]');
    if (!showcase) return;

    const track = showcase.querySelector('[data-showcase-track]');
    const slides = Array.from(showcase.querySelectorAll('[data-showcase-slide]'));
    const prev = showcase.querySelector('[data-showcase-prev]');
    const next = showcase.querySelector('[data-showcase-next]');
    const dots = Array.from(showcase.querySelectorAll('[data-showcase-dot]'));

    if (!track || slides.length <= 1) return;

    let current = 0;

    const update = () => {
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    };

    if (prev) {
      prev.addEventListener('click', () => {
        current = current === 0 ? slides.length - 1 : current - 1;
        update();
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        current = current === slides.length - 1 ? 0 : current + 1;
        update();
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        current = Number(dot.dataset.index);
        update();
      });
    });

    update();
  }

  function initReports() {
    const reports = root.querySelector('[data-sdjhs-reports]');
    if (!reports) return;

    const track = reports.querySelector('[data-reports-track]');
    const slides = Array.from(reports.querySelectorAll('[data-report-slide]'));
    const dots = Array.from(reports.querySelectorAll('[data-report-dot]'));

    if (!track || slides.length <= 1) return;

    let current = 0;
    const mq = window.matchMedia('(max-width: 749px)');

    const update = () => {
      if (mq.matches) {
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
      } else {
        track.style.transform = 'translateX(0)';
      }

      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        current = Number(dot.dataset.index);
        update();
      });
    });

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', update);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(update);
    }

    update();
  }

  initHero();
  initShowcase();
  initReports();
  }

  function initAll(scope) {
    if (scope.matches && scope.matches('.sdjhs')) initRoot(scope);
    scope.querySelectorAll('.sdjhs').forEach(initRoot);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();

